"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionHistoryResponseToJSON = exports.TransactionHistoryResponseFromJSONTyped = exports.TransactionHistoryResponseFromJSON = exports.instanceOfTransactionHistoryResponse = void 0;
var runtime_1 = require("../runtime");
var Transaction_1 = require("./Transaction");
/**
 * Check if a given object implements the TransactionHistoryResponse interface.
 */
function instanceOfTransactionHistoryResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTransactionHistoryResponse = instanceOfTransactionHistoryResponse;
function TransactionHistoryResponseFromJSON(json) {
    return TransactionHistoryResponseFromJSONTyped(json, false);
}
exports.TransactionHistoryResponseFromJSON = TransactionHistoryResponseFromJSON;
function TransactionHistoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transactions': !(0, runtime_1.exists)(json, 'transactions') ? undefined : (json['transactions'].map(Transaction_1.TransactionFromJSON)),
    };
}
exports.TransactionHistoryResponseFromJSONTyped = TransactionHistoryResponseFromJSONTyped;
function TransactionHistoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transactions': value.transactions === undefined ? undefined : (value.transactions.map(Transaction_1.TransactionToJSON)),
    };
}
exports.TransactionHistoryResponseToJSON = TransactionHistoryResponseToJSON;
